import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface DNSRecordListErrorProps {
  error: string;
  onRetry: () => void;
}

const DNSRecordListError: React.FC<DNSRecordListErrorProps> = ({ error, onRetry }) => {
  return (
    <motion.div className="text-center py-8" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-3">
        <AlertCircle className="w-6 h-6 text-red-600 dark:text-red-400" />
      </div>
      <p className="text-body-small text-red-600 dark:text-red-400 mb-2">
        Failed to load DNS records
      </p>
      <p className="text-body-small text-slate-500 dark:text-slate-400 mb-4">{error}</p>
      <motion.button
        className="inline-flex items-center justify-center px-4 py-2 text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 hover:border-slate-300 focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed text-sm"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={onRetry}
      >
        <RefreshCw className="w-4 h-4 mr-2" />
        Retry
      </motion.button>
    </motion.div>
  );
};

export default DNSRecordListError;